<template>
  <div class="row justify-content-center align-items-center">
    <div class="card" style="width: 300px;
    padding: 20px;
    margin-top: 50px;">
        You are not authorized to access this model or this model is not found.
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">

</style>
